import React from 'react';

export const ZeplinIconBorderless = () => (
	<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.77432 9.58215L1.83263 9.91452L1.78223 12.6201L5.0417 11.4703C3.92361 11.1075 3.10732 10.4691 2.77432 9.58215Z"
			fill="#FDBD39"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.26698 6.72028L0 7.87298L1.83299 9.91442L2.77438 9.58205C2.44228 8.69767 2.64688 7.69825 3.26698 6.72028Z"
			fill="#F69833"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.76532 2.81617C4.60465 4.28414 1.92237 7.31341 2.77436 9.58231L17.8406 4.26618C16.9886 1.99727 12.9257 1.34819 8.76532 2.81617Z"
			fill="#FECF33"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.8499 11.0322C16.0103 9.56393 18.6973 6.54829 17.8408 4.26605L2.77405 9.58219C3.63084 11.8644 7.68921 12.5002 11.8499 11.0322Z"
			fill="#EE6723"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.8408 4.26605L2.77405 9.58219C3.06895 10.368 4.19424 10.7552 5.77253 10.7552C7.31152 10.7552 9.2816 10.3875 11.3354 9.66274C15.4958 8.19476 18.4228 5.81777 17.8402 4.26605"
			fill="#F69833"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.842 3.09308C13.3031 3.09308 11.333 3.4608 9.27918 4.18551C5.11881 5.65349 2.19173 8.03019 2.77433 9.5822L17.8405 4.26607C17.5456 3.48021 16.4206 3.09308 14.842 3.09308Z"
			fill="#FDBD39"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.0099 12.7637C13.5665 12.7637 12.9128 12.3769 12.0659 11.6142C11.0648 10.7118 9.91765 9.39021 8.83585 7.89238C7.75436 6.39513 6.86547 4.89789 6.33327 3.6768C5.75368 2.34617 5.67088 1.52815 6.08757 1.24504C6.17907 1.18303 6.28917 1.15173 6.41517 1.15173C6.75417 1.15173 7.41476 1.39543 8.63606 2.55712L8.66306 2.58233L8.65916 2.61855C8.65076 2.70201 8.64326 2.78633 8.63636 2.86891L8.62286 3.03293L8.50286 2.91644C7.18677 1.63565 6.60747 1.49743 6.41937 1.49743C6.36567 1.49743 6.32307 1.50786 6.29247 1.52873C6.11157 1.6513 6.09987 2.25228 6.66207 3.54205C7.18497 4.74141 8.06066 6.21577 9.12805 7.69389C10.196 9.1723 11.3255 10.4745 12.3092 11.3606C13.3697 12.3163 13.8476 12.4195 14.0042 12.4195C14.0582 12.4195 14.1017 12.4085 14.1344 12.3861C14.3249 12.2569 14.3252 11.613 13.6982 10.2245L13.6694 10.161L13.7324 10.1277C13.7954 10.0943 13.8566 10.0616 13.9136 10.0303L13.9892 9.98887L14.024 10.0657C14.4683 11.0494 14.8838 12.2998 14.339 12.6698C14.2472 12.7321 14.1365 12.7637 14.0099 12.7637Z"
			fill="#EE6723"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.9507 10.9907L11.9447 11.0661C11.8394 12.3234 11.5622 13.8345 10.8401 13.896C10.8257 13.8971 10.8107 13.8977 10.7957 13.8977C10.3049 13.8977 9.84084 13.2188 9.41634 11.88C9.01434 10.6131 8.70235 8.91277 8.53825 7.09098C8.37385 5.27006 8.37625 3.54245 8.54515 2.22718C8.72905 0.793682 9.07944 0.0452042 9.58644 0.00202839C9.60144 0.000869312 9.61704 0 9.63234 0C9.98814 0 10.5245 0.389452 11.0735 2.20226L10.715 2.2689C10.5317 1.66328 10.3319 1.17067 10.1336 0.831642C9.95004 0.51869 9.77184 0.346276 9.63144 0.346276C9.62664 0.346276 9.62214 0.346276 9.61734 0.346856C9.39774 0.365401 9.07764 0.880323 8.89945 2.26977C8.73355 3.56157 8.73145 5.26311 8.89345 7.06084C9.05604 8.85887 9.36264 10.5343 9.75744 11.7783C9.93414 12.3352 10.1279 12.7945 10.3181 13.106C10.4933 13.3935 10.6628 13.5517 10.7954 13.5517C10.7999 13.5517 10.8044 13.5517 10.8092 13.5511C11.0192 13.5335 11.4155 12.9977 11.5823 11.1127L11.9507 10.9907Z"
			fill="#EE6723"
		/>
	</svg>
);
